import { Box, Button, Group, Modal, ModalProps, TextInput } from '@mantine/core';
import { isEmail, useForm } from '@mantine/form';
import { useDisclosure } from '@mantine/hooks';
import { useTranslation } from 'react-i18next';
import { sendEmailVerification } from '@mygpt/app';

interface Props extends ModalProps {
  onConfirm: () => void;
}

export default ({ onClose, onConfirm, opened }: Props) => {
  const { t } = useTranslation();
  const [loading, { close, open }] = useDisclosure(false);

  const form = useForm({
    initialValues: {
      email: '',
    },
    validate: {
      email: isEmail('Invalid email'),
    },
  });

  const submit = async (values: { email: string }) => {
    open();
    sendEmailVerification(values)
      .then(() => {
        onConfirm();
        onClose();
      })
      .finally(() => {
        close();
      });
  };

  return (
    <Modal title={t('email_input_confirm')} centered opened={opened} onClose={onClose}>
      <Box component="form" mt={30} maw={400} mx="auto" onSubmit={form.onSubmit(submit)}>
        <TextInput data-autofocus placeholder="Email" {...form.getInputProps('email')} />
        <Group justify="flex-end" mt={30}>
          <Button variant="outline" onClick={onClose}>
            {t('alert_cancel')}
          </Button>
          <Button loading={loading} type="submit">
            {t('alert_ok')}
          </Button>
        </Group>
      </Box>
    </Modal>
  );
};
